import React, { useState } from 'react';
import { sendInvitation } from '../../api/user';
import { toast } from 'react-toastify';
import { SkeletonBlock, SkeletonText } from "../../components/Skeleton/Skeleton";

const Invitation = ({ isOpen, onClose, gameId }) => {
  const [emailInput, setEmailInput] = useState("");
  const [emailList, setEmailList] = useState([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  // Email validation function
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const processEmailInput = (input) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return input
      .split(/[\n\s,;]+/) // Split by new lines, spaces, commas, or semicolons
      .map((email) => email.trim())
      .filter((email) => email && emailRegex.test(email)); // Filter valid emails
  };

  // Handle send button click
  // const handleSend = async () => {
  //   const data = {
  //     game_id: gameId,
  //     emails: processEmailInput(emailInput)
  //   };

  //   setIsLoading(true); // Start loader

  //   try {
  //     const response = await sendInvitation(data);
  //     console.log(response);

  //     setEmailInput("");
  //     setEmailList([]);
  //     // Show success toast if API call is successful
  //     toast.success("Invitation sent successfully!");
  //   } catch (error) {
  //     console.error("Error sending invitation:", error);

  //     // Show error toast if API call fails
  //     toast.error("There was an issue sending the invitation. Please try again.");
  //   } finally {
  //     setIsLoading(false); // Stop loader
  //     onClose(); // Close the modal
  //   }
  // };

  const handleSend = async () => {
  const data = {
    game_id: gameId,
    emails: processEmailInput(emailInput),
  };

  setIsLoading(true); // Start loader

  try {
    const response = await sendInvitation(data); // Assuming response is a JSON object
  console.log(response,'rs');
    if (response?.status==200 && response.data.status!=400) {
      // Show success toast with the backend message
      toast.success(response.data.message || "Invitation sent successfully!");
      setEmailInput("");
      setEmailList([]);
    } else {
      // Show error toast with the backend message
      toast.error("Could not send invitations. Try again.");
    }
  } catch (error) {
    console.error("Error sending invitation:", error);

    // Handle any unexpected errors during the API call
    toast.error("Could not send invitations. Try again.");
  } finally {
    setIsLoading(false); // Stop loader
    onClose(); // Close the modal
  }
};


  const processEmails = (input) => {
    // Split input into lines or by common delimiters, trim, and filter valid emails
    const emails = input
      .split(/[\n\s,;]+/) // Split on new lines, spaces, commas, or semicolons
      .map((email) => email.trim())
      .filter((email) => email && isValidEmail(email)); // Keep valid emails

    return emails.join("\n"); // Join valid emails with new lines
  };

  const handleChange = (e) => {
    const input = e.target.value;

    // Process user-typed input
    const processedEmails = processEmails(input);

    if (processedEmails.split("\n").length > 600) {
      setError("You can have up to 600 email addresses at a time.");
      return;
    }

    setEmailInput(input); // Allow typing freely
    setError(""); // Clear any errors
  };

  const handleBlur = () => {
    // Process and validate the input when the user leaves the textarea
    const processedEmails = processEmails(emailInput);
    if (processedEmails) {
      setEmailInput(processedEmails);
      setError(""); // Clear any error if there are valid emails
    } else {
      setError("Please enter at least one valid email address.");
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text");

    // Process and validate pasted emails
    const pastedEmails = processEmails(pastedData);

    const currentEmails = processEmails(emailInput).split("\n");
    const allEmails = [...currentEmails, ...pastedEmails.split("\n")];

    if (allEmails.length > 600) {
      setError("You can paste up to 600 email addresses at a time.");
      return;
    }

    setEmailInput(allEmails.join("\n").trim());
    setError(""); // Clear any errors
  };

  const handleClose = () => {
    onClose();
    setEmailInput("");
    setEmailList([]);
    setError("");
  };

  return (
    <div className="relative z-40" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="fixed inset-0 bg-[#000000AB] bg-opacity-75 transition-opacity" aria-hidden="true"></div>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            {isLoading ? (
              // Modal shell is already on screen; only its content waits.
              <div className="px-4 pb-4 pt-5 sm:p-6" aria-busy="true">
                <SkeletonBlock height={64} width={64} className="mx-auto" />
                <SkeletonBlock height={16} width="60%" className="mx-auto mt-5" />
                <SkeletonText lines={2} height={12} lastLineWidth="50%" className="mt-4" />
              </div>
            ) : (
              // Modal content when not loading
              <>
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="flex justify-center items-center mb-4">
                      <img src={"/qushi_logo.png"} alt="Logo" className="h-16 w-auto" />
                    </div>
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <h3 className="text-base font-semibold text-gray-900" id="modal-title">
                        Invitation
                      </h3>
                      <div className="mt-2">
                        <form onSubmit={(e) => e.preventDefault()}>
                          <label htmlFor="emailInput" className="text-sm text-gray-500">
                            Enter Email Addresses (one per line):
                          </label>
                          <textarea
                            id="emailInput"
                            className="mt-2 w-full border border-gray-300 rounded p-2"
                            placeholder="Type or paste email addresses here"
                            value={emailInput}
                            onChange={handleChange} // Allow free typing
                            onBlur={handleBlur} // Validate on blur (focus loss)
                            onPaste={handlePaste} // Validate on paste
                            rows={7}
                          />

                          {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
                          <div className="mt-4">
                            {emailList.map((email, index) => (
                              <div key={index} className="text-sm text-gray-700 mb-1">
                                {email}
                              </div>
                            ))}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-full bg-[#1D5157] py-2 px-6 text-sm text-white sm:ml-3 sm:w-auto"
                    onClick={handleSend}
                    disabled={!emailList.length && !emailInput} // Disable if no emails entered
                  >
                    Send
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-full bg-white py-2 px-6 text-sm ring-1 ring-inset ring-gray-300 sm:mt-0 sm:w-auto"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invitation;
